import React from 'react';
import cn from 'classname';

const CategorySelector = props => {
	return !!props.categories && !!props.categories.length && (
		<div className="category-selector">
			{props.categories.map((ctg, index) => (
				<span
					className={cn('item', props.selectedCategoryIds.includes(ctg.category_id) && 'active')}
					key={index}
					onClick={() => props.toggleCategoryFilter(ctg.category_id)}
				>
					{ctg.category_name}
				</span>
			))}
		</div>
	);
};

export default CategorySelector;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/bm-accounts/components/category-selector.js